import { z } from 'zod';
import { BaseErrorSchema } from '../../../../shared/error.schema';
import { SuperAdminUserSchema } from '../../entities/superadmin-user';
/**
 * List SuperAdmin Users Response Schema
 * GET /api/v2/superadmin-users
 *
 * Returns all superadmin users in the SuperAdmin database
 * Only accessible by authenticated superadmins
 */ export const ListSuperAdminUsersResponseSchema = z.array(SuperAdminUserSchema);
/**
 * List SuperAdmin Users Error Schema
 * Returned when retrieval fails
 */ export const ListSuperAdminUsersErrorSchema = BaseErrorSchema;

//# sourceMappingURL=list-superadmin-users.schema.js.map